import { render, staticRenderFns } from "./ekyc-complete.vue?vue&type=template&id=5a905ffe&"
import script from "./ekyc-complete.vue?vue&type=script&lang=js&"
export * from "./ekyc-complete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports